import { makeStyles } from "@material-ui/core"

export const tabStyles = makeStyles((theme) => ({
    tabsWrapper: {
        margin: '1em 0'
    }
}));